import { render } from "./DivisionLeadersThurA.vue?vue&type=template&id=37c418d6&scoped=true"
import script from "./DivisionLeadersThurA.vue?vue&type=script&scoped=true&lang=js"
export * from "./DivisionLeadersThurA.vue?vue&type=script&scoped=true&lang=js"

import "./DivisionLeadersThurA.vue?vue&type=style&index=0&id=37c418d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c418d6"]])

export default __exports__